<template>
  <li v-if="isVisible" class="nav-group" :class="`${toggled ? 'opened-dropdown': 'closed-dropdown'}`">
    <button class="nav-group-title" @click="toggled = !toggled" id="users-button" :aria-expanded="toggled" aria-controls="users-expanded">
      <i class="k-asset-icon fa-duotone fa-building-user" aria-hidden="true"></i><span>Users</span>
      <i class="fas fa-angle-down" aria-hidden="true"></i>
    </button>
    <ul class="second-level" v-if="toggled" id="users-expanded" aria-labelledby="users-button" :hidden="!toggled">
      <li v-if="$permissions.hasPermission('manage_coaches') || $permissions.hasPermission('manage_mentors')" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{  name: 'learner_support'}">
            <span>Learner Support</span>
          </router-link>
        </div>
      </li>
      <li class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{  name: 'users_trainer'}">
            <span>Trainers</span>
          </router-link>
        </div>
      </li>
      <li v-if="$permissions.hasPermission('merge_employers')" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'employer_merging'}">
            <span>Employer Merging</span>
          </router-link>
        </div>
      </li>
      <li v-if="$permissions.hasPermission('manage_roles')" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'users_privileged_users'}">
            <span>Privileged Users</span>
          </router-link>
        </div>
      </li>
      <li
        v-if="$permissions.hasPermission('migrate_programme_progress') && $featureFlags.isEnabled('progress-migration-planner')"
        class="nav-sub-group"
      >
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'progress_migration_planner' }">
            <span>Progress Migration</span>
          </router-link>
        </div>
      </li>
    </ul>
  </li>
</template>

<style>
  .sidebar-panel .nav-sub-group.nav-sub-dropdown.no-dropdown .nav-sub-group-dropdown-title {
    padding-right: 0;
  }

  .nav-group {
    list-style: none;
  }
</style>

<script>
import SidebarEntryMixin from '@mixins/sidebar-entry-mixin';

export default {
  mixins: [SidebarEntryMixin],

  data() {
    return {
      toggled: false,
    };
  },

  computed: {
    isVisible() {
      return this.hasUsersPermissions;
    },

    hasUsersPermissions() {
      return this.$permissions.hasPermission('manage_coaches')
        || this.$permissions.hasPermission('manage_mentors')
        || this.$permissions.hasPermission('manage_roles')
        || this.$permissions.hasPermission('merge_employers')
        || this.$permissions.hasPermission('migrate_programme_progress');
    },
  },
};
</script>
